import { type ReactElement, } from "react";
import styled from "styled-components";
import { Svg, } from "@bracket/ui/nodes";

export declare type ChevronLeftProps = {
	className?: string;
	style?: React.CSSProperties;
}

export const ChevronLeft = ({
	className = "",
	style = {},
}: ChevronLeftProps): ReactElement => {
	const classes = [ `icon`, `chevron`, `chevron-left`, ...className.split(" ") ].filter(v => v).join(" ");
	return (
		<IconFrame className={classes} style={style}>
			<Svg
				viewBox="0 0 16 10"
				xmlns="http://www.w3.org/2000/svg"
				fill="currentColor"
				preserveAspectRatio="xMidYMid meet"
				style={{ transform: "rotate(-90deg)" }}>
				<title>Chevron Left</title>
				<path d="M13.6963 9.04401L8.47667 3.82443L3.25709 9.04401C2.73244 9.56866 1.88493 9.56866 1.36028 9.04401C0.835635 8.51936 0.835635 7.67186 1.36028 7.14721L7.535 0.972495C8.05964 0.447846 8.90715 0.447846 9.4318 0.972495L15.6065 7.14721C16.1312 7.67185 16.1312 8.51936 15.6065 9.04401C15.0819 9.55521 14.2209 9.56866 13.6963 9.04401Z" fill="currentColor"/>
			</Svg>
		</IconFrame>
	);
};

const IconFrame = styled.div<{ width?: string; height?: string; }>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	height: ${({ height, }) => height ? `${height}` : "100%"};
	width: ${({ width, }) => width ? `${width}` : "100%"};
	max-width: ${({ width, }) => width ? `${width}` : "100%"};
	max-height: ${({ height, }) => height ? `${height}` : "100%"};
`;



























